import { apiGet, apiPost } from '../../../utils/http';

export default function generateHireAgreementCrud(toApiUrl) {
  const SUBMIT_FORM_URL = toApiUrl('/hire-agreement');
  const VALIDATE_FORM_URL = toApiUrl('/hire-agreement/validate');
  const SUCCESS_URL = toApiUrl('/hire-agreement/get-success');
  const CAPTCHA_URL = toApiUrl('/captcha');
  const LOCATION_ADDRESS_URL = (locationName) =>
   toApiUrl(`/locations/by-name/${encodeURIComponent(locationName)}`);

  function submitForm(payload) {
    return apiPost(SUBMIT_FORM_URL, payload);
  }


  function checkCaptcha(payload) {
    return apiPost(CAPTCHA_URL, payload);
  }

  function validateForm(payload) {
    return apiGet(VALIDATE_FORM_URL, payload);
  }

  function getSuccess(payload) {
    return apiGet(SUCCESS_URL, payload);
  }

  function getLocationAddress(locationName) {
    return apiGet(LOCATION_ADDRESS_URL(locationName));
  }

  return {
    submitForm,
    checkCaptcha,
    validateForm,
    getSuccess,
    getLocationAddress
  };
} 
